export default __webpack_public_path__ + "static/media/img-color-check-w.a74a2eac.svg";